import { Component, Input } from '@angular/core';
import { SectorInBookingType } from "@afidium/ts-facade/model/sectorInBookingType";

@Component({
    selector: 'sector-header',
    template: `
        <div class="sectors-container">
            <div class="sectors-list">
                <sectors-air-simple-list
                        class="main-informations"
                        [sectors]="sectors" [showBeginEndTime]="showBeginEndTime"></sectors-air-simple-list>
            </div>
        </div>
        <sectors-air-summary-with-rupture *ngIf="sectorsDetailsShown"
                                          [sectors]="sectors"></sectors-air-summary-with-rupture>
    `,
    styles: [`
        .sectors-container {
            display: flex;
            align-items: baseline;
            font-weight: bold;
        }


        .sectors-list {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }

        .main-informations {
            min-width: 80%;
            margin-right: .75rem;
        }

    `]
})

export class SectorHeaderComponent {

    @Input()
    public sectors: SectorInBookingType[];

    @Input()
    public rateType: string;

    @Input()
    public showBeginEndTime: boolean = false;

    public sectorsDetailsShown: boolean = false;
}